import Vue from 'vue'
import moment from 'moment'
import { isNull, filterParams } from '@/utils'
Vue.filter('filterParams', val => {
  if (isNull(val)) {
    return '--'
  }
  return val
})

/* 时间戳转换成时间 */
Vue.filter('timeStampToString', (value, showMinutes = true) => {
  if (isNull(value)) {
    return '--'
  } else {
    if (showMinutes) return moment(value).format('YYYY-MM-DD HH:mm:ss')
    else return moment(value).format('YYYY-MM-DD')
  }
})

/* 给对象数组转译  */
Vue.filter('listFilter', (value, list, key = 'value', show = 'label') => {
  if (!isNull(value) && list && list.length > 0) {
    if (!isNull(filterParams(value, list, key))) {
      return filterParams(value, list, key)[show]
    } else {
      return value
    }
  }
  return '--'
})

Vue.filter('betchListFilter', (value, list, key, show) => {
  if (!isNull(value) && value instanceof Array && list && list.length > 0) {
    return value
      .map(val => {
        if (!isNull(filterParams(val, list, key))) {
          return filterParams(val, list, key)[show]
        } else {
          return val || '--'
        }
      })
      .join(',')
  }
  return '--'
})
